/**
 *  @class
 *  @function RecentlyViewedProducts
 */
if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();
      this.url = theme.routes.search_url + '?view=recently-viewed&type=product&q=';
      this.container = this.querySelector('.products');
      this.currentId = this.dataset.productHandle;
      this.max = 5;
      this.products = '';
      this.desktopSwipe = this.dataset.desktopSwipe === 'true';
      this.flickity = null;
      
      // Initialize recently viewed products from localStorage
      if (window.localStorage) {
        this.initializeRecentlyViewed();
      }
      
      // Bind methods
      this.onResize = this.onResize.bind(this);
    }

    initializeRecentlyViewed() {
      let recentIds = window.localStorage.getItem('recently-viewed');
      if (recentIds && typeof (recentIds) !== undefined) {
        window.recentlyViewedIds = JSON.parse(recentIds);
      }
    }

    connectedCallback() {
      this.buildUrl();
      
      // Add resize listener for Flickity
      if (this.desktopSwipe) {
        window.addEventListener('resize', this.onResize);
      }
    }

    disconnectedCallback() {
      // Clean up resize listener
      if (this.desktopSwipe) {
        window.removeEventListener('resize', this.onResize);
      }
      
      // Destroy Flickity instance if it exists
      this.destroyFlickity();
    }

    onResize() {
      if (this.desktopSwipe) {
        // Debounce the resize event
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => {
          const isDesktop = window.innerWidth >= 768;
          
          if (isDesktop && !this.flickity) {
            this.initFlickity();
          } else if (!isDesktop && this.flickity) {
            this.destroyFlickity();
          }
        }, 250);
      }
    }

    destroyFlickity() {
      if (this.flickity) {
        this.flickity.destroy();
        this.flickity = null;
      }
    }

    initFlickity() {
      // Only initialize on desktop when enabled
      if (this.desktopSwipe && window.innerWidth >= 768) {
        const productCount = this.container.querySelectorAll('.columns').length;
        // Configure Flickity options
        const flickityOptions = {
          cellAlign: 'left',
          contain: true,
          pageDots: false,
          prevNextButtons: true,
          wrapAround: false,
          cellSelector: '.columns',
          draggable: '>1',
          
        };

        // Initialize Flickity
        this.flickity = new Flickity(this.container, flickityOptions);

        if (productCount >= 5) {
          this.setupCustomNavigation();
          this.updateNavigationState();
        } else {
          // Hide navigation arrows if less than 5 products
          const prevButton = this.querySelector('.flickity-prev');
          const nextButton = this.querySelector('.flickity-next');
          if (prevButton) prevButton.style.display = 'none';
          if (nextButton) nextButton.style.display = 'none';
        }
      }
    }

    setupCustomNavigation() {
      const prevButton = this.querySelector('.flickity-prev');
      const nextButton = this.querySelector('.flickity-next');
      
      if (prevButton && nextButton) {
        // Add click handlers
        prevButton.addEventListener('click', () => {
          this.flickity.previous();
          this.updateNavigationState();
        });
        
        nextButton.addEventListener('click', () => {
          this.flickity.next();
          this.updateNavigationState();
        });

        // Listen for Flickity scroll events
        this.flickity.on('scroll', () => {
          this.updateNavigationState();
        });
      }
    }

    updateNavigationState() {
      if (!this.flickity) return;

      const prevButton = this.querySelector('.flickity-prev');
      const nextButton = this.querySelector('.flickity-next');
      
      if (prevButton && nextButton) {
        // Check if we're at the start or end
        const isStart = this.flickity.selectedIndex === 0;
        const isEnd = this.flickity.selectedIndex === this.flickity.slides.length - 1;
        
        // Update button states
        prevButton.classList.toggle('is-disabled', isStart);
        nextButton.classList.toggle('is-disabled', isEnd);
      }
    }

    buildUrl() {
      let i = 0;
      window.recentlyViewedIds.forEach((val) => {
        // Skip current product
        if (val === this.currentId) {
          return;
        }
        // Stop at max
        if (i >= this.max) {
          return;
        }
        this.products += 'handle:' + val + ' OR ';
        i++;
      });
      
      this.url = this.url + encodeURIComponent(this.products);
      this.fetchProducts();
    }

    fetchProducts() {
      fetch(this.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.products');
          
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.container.innerHTML = recommendations.innerHTML;
            this.classList.add('product-recommendations--loaded');
            
            // Initialize Flickity after content is loaded
            this.initFlickity();
          } else {
            // Hide the component if no recommendations
            this.style.display = 'none';
          }
        })
        .catch(e => {
          console.error('Error fetching recently viewed products:', e);
          // Hide the component on error
          this.style.display = 'none';
        });
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}